import type { DashboardDto } from "@stryker/core/types/dashboard";
import DynamicTable from "@/components/dashboard/DynamicTable";
import { Typography } from "@/components/ui/typography";

type RevenuePieProps = {
  graphsData?: DashboardDto["revenuePieChart"];
};
export default function RevenueTables({ graphsData }: RevenuePieProps) {
  return (
    <div className="flex flex-col max-w-[80%] gap-8 p-4">
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Revenue % by branch
        </Typography>
        <DynamicTable data={graphsData?.byBranch.map((v) => revenueCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Revenue % by plant
        </Typography>
        <DynamicTable data={graphsData?.byPlant.map((v) => revenueCountToPercentage(v)) ?? []} />
      </div>

      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Revenue % by person
        </Typography>
        <DynamicTable data={graphsData?.byPerson.map((v) => revenueCountToPercentage(v)) ?? []} />
      </div>

      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Revenue % by kit size
        </Typography>
        <DynamicTable data={graphsData?.byKitsSize.map((v) => revenueCountToPercentage(v)) ?? []} />
      </div>
    </div>
  );
}

const revenueCountToPercentage = (v: any) => {
  return {
    ...v,
    revenue: Number.parseFloat((v.revenue * 100).toFixed(1)) + "%",
  };
};
